import axios from '@/libs/api.request'
// 获取video信息
export const getVideoUserSign = data => {
  return axios.request({
    url: '/video/user/sig',
    data,
    method: 'POST'
  })
}
export const getScreenVideoUserSign = data => {
  return axios.request({
    url: '/video/screen/sharing/user/sig',
    data,
    method: 'POST'
  })
}
// 获取om-video信息
export const getOmVideoUserSign = data => {
  return axios.request({
    url: '/video/test/user/sig',
    data,
    method: 'POST'
  })
}
// 获取导师num
export const getOmMenteeNum = data => {
  return axios.request({
    url: '/self/role/id',
    data,
    method: 'POST'
  })
}
